var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("br"),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c(
      "div",
      { style: { borderBottom: "1px solid #E9E9E9" } },
      [
        _c(
          "a-row",
          [
            _c(
              "a-col",
              { attrs: { "a-col": "", span: "24", align: "middle" } },
              [
                _c("h3", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v("我的创意")
                ])
              ]
            )
          ],
          1
        )
      ],
      1
    ),
    _c("br"),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("a-table", {
          attrs: {
            pagination: "false",
            columns: _vm.columns,
            dataSource: _vm.result
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function(text, record) {
                return _c("span", {}, [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          return _vm.handleEdit(record)
                        }
                      }
                    },
                    [_vm._v("编辑")]
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          return _vm.handleDelete(record)
                        }
                      }
                    },
                    [_vm._v("删除")]
                  )
                ])
              }
            }
          ])
        }),
        _c("br"),
        _vm._v(" "),
        _c(
          "a-row",
          [
            _c(
              "a-col",
              { attrs: { "a-col": "", span: "24", align: "middle" } },
              [
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.addDevice()
                      }
                    }
                  },
                  [_vm._v("提交新创意")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }